import { mapActions, mapGetters } from 'vuex';
import { parseISO, addHours } from 'date-fns';
import _get from 'lodash/get';

import { DEFAULT_LEAD_EXPIRATION_HOURS } from '@/constants';
import {
  NEW_MATCH_STATUSES,
  MATCH_STATUS_ACTIONS,
  getMatchStatusActionsMessage,
} from '@/constants/match-statuses';
import { URGENCY_LABELS, DEFAULT_URGENCY } from '@/constants/urgencies';
import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export default {
  REQUEST_LIFECYCLE,
  MATCH_STATUSES: NEW_MATCH_STATUSES,
  MATCH_STATUS_ACTIONS,
  getMatchStatusActionsMessage,
  URGENCY_LABELS,
  DEFAULT_URGENCY,
  computed: {
    ...mapGetters('entities', {
      workOrderEntities: 'proWorkOrders',
      workOrderMatchEntities: 'proWorkOrdersMatches',
      // jobEntities: 'jobs', // To be remove
      // matchEntities: 'matches', // To be remove
    }),
    // More work needed
    ...mapGetters('dashboard/job', [
      'currentJobMeta',
      'currentRawJob',
    ]),
    job () {
      const job = this.workOrderEntities[this.jobId];
      return (
        job && {
          ...job,
          time_created: addUTCTimeZoneDesignator(job.time_created),
        }
      );
    },
    match () {
      if (!this.jobId) {
        return;
      }
      const matchId = _get(this.job, 'matches');
      const match = this.workOrderMatchEntities[matchId];

      return (
        match && {
          ...match,
          status: match.status.toLowerCase(),
          time_created: addUTCTimeZoneDesignator(match.time_created),
          // time_seen_consumer: addUTCTimeZoneDesignator(match.time_seen_consumer),
          time_seen_pro: addUTCTimeZoneDesignator(match.time_seen_pro),
          time_updated: addUTCTimeZoneDesignator(match.time_updated),
          time_ask_later: addUTCTimeZoneDesignator(match.time_ask_later),
        }
      );
    },
    timeToExpire () {
      const timeCreated = _get(this.match, 'time_created');

      if (!timeCreated) {
        return;
      }
      return addHours(parseISO(timeCreated), DEFAULT_LEAD_EXPIRATION_HOURS).toISOString();
    },
    isNewMatch () {
      const { UNREPLIED, ACCEPTED } = this.$options.MATCH_STATUSES;
      const status = _get(this.match, 'status');

      return [UNREPLIED, ACCEPTED].includes(status);
    },
    isPotentialMatch () {
      const status = _get(this.match, 'status');

      return status === this.$options.MATCH_STATUSES.POTENTIAL;
    },
    isHiredMatch () {
      const status = _get(this.match, 'status');

      return status === this.$options.MATCH_STATUSES.HIRED;
    },
    isCompletedMatch () {
      const status = _get(this.match, 'status');

      return status === this.$options.MATCH_STATUSES.COMPLETED;
    },
    isClosedMatch () {
      const status = _get(this.match, 'status');

      return status === this.$options.MATCH_STATUSES.CLOSED;
    },
    isFinishedMatch () {
      const {
        COMPLETED,
        CANCELED,
        REJECTED,
        CLOSED,
        UNRESPONSIVE,
      } = this.$options.MATCH_STATUSES;
      const status = _get(this.match, 'status');

      return [COMPLETED, CANCELED, REJECTED, CLOSED, UNRESPONSIVE].includes(status);
    },
  },
  methods: {
    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
    ]),

    // To Be remove
    ...mapActions('dashboard/job', [
      // 'fetchJob',
      'transitionJob',
    ]),
  },
};
